<template>
  <div id="base-autocomplete-place">
    <form autocomplete="off">
      <v-layout align-center row v-if="verticalMode" wrap>
        <v-flex xs12>
          <!-- Country -->
          <!-- <v-autocomplete
            :items="countrys"
            @input="$emit('countryId', formData.countryId)"
            solo
            
            item-text="nametha"
            item-value="id"
            label="Country"
            v-model="formData.countryId"
          ></v-autocomplete>-->
          <!-- region -->
          <!-- <v-autocomplete
            :items="regions"
            @input="checkRegion"
            solo
            
            clearable
            item-text="nametha"
            item-value="idx"
            label="Region"
            v-model="formData.regionId"
          ></v-autocomplete>-->
          <!-- province -->
          <v-autocomplete
            :items="provinces"
            @input="checkProvince"
            clearable
            item-text="nametha"
            item-value="id"
            label="จังหวัด"
            solo
            v-model="formData.provinceId"
          ></v-autocomplete>
          <!-- district -->
          <v-autocomplete
            :disabled="formData.provinceId ? false : true"
            :items="districts"
            @input="checkDistrict"
            clearable
            item-text="nametha"
            item-value="id"
            label="อำเภอ"
            solo
            v-model="formData.districtId"
          ></v-autocomplete>
          <!-- sub district -->
          <v-autocomplete
            :disabled="formData.districtId ? false : true"
            :items="subDistricts"
            @input="$emit('subDistrictId', formData.subDistrictId)"
            clearable
            item-text="nametha"
            item-value="id"
            label="ตำบล"
            solo
            v-model="formData.subDistrictId"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout align-center row v-else wrap>
        <v-flex pt-0 xs2>
          <!-- Country -->
          <v-autocomplete
            :items="countrys"
            @input="$emit('countryId', formData.countryId)"
            item-text="nametha"
            item-value="id"
            label="Country"
            solo
            v-model="formData.countryId"
          ></v-autocomplete>
        </v-flex>
        <v-flex pt-0 xs2>
          <!-- region -->
          <v-autocomplete
            :items="regions"
            @input="checkRegion"
            clearable
            item-text="nametha"
            item-value="idx"
            label="Region"
            solo
            v-model="formData.regionId"
          ></v-autocomplete>
        </v-flex>
        <v-flex pt-0 xs3>
          <!-- province -->
          <v-autocomplete
            :disabled="formData.regionId ? false : true"
            :items="provinces"
            @input="checkProvince"
            clearable
            item-text="nametha"
            item-value="id"
            label="Province"
            solo
            v-model="formData.provinceId"
          ></v-autocomplete>
        </v-flex>
        <v-flex pt-0 xs2>
          <!-- district -->
          <v-autocomplete
            :disabled="formData.provinceId ? false : true"
            :items="districts"
            @input="checkDistrict"
            clearable
            item-text="nametha"
            item-value="id"
            label="District"
            solo
            v-model="formData.districtId"
          ></v-autocomplete>
        </v-flex>
        <v-flex pt-0 xs3>
          <!-- sub district -->
          <v-autocomplete
            :disabled="formData.districtId ? false : true"
            :items="subDistricts"
            @input="$emit('subDistrictId', formData.subDistrictId)"
            clearable
            item-text="nametha"
            item-value="id"
            label="Sub District"
            solo
            v-model="formData.subDistrictId"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
export default {
  name: 'base-autocomplete-place',
  props: {
    verticalMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formData: []
    }
  },
  computed: {
    // countrys() {
    //   return this.$store.getters['Place/getCountryAll']
    // },
    // regions() {
    //   return this.$store.getters['Place/getRegionAll']
    // },
    provinces() {
      return this.$store.getters['Place/getProvinceAll']
      //   return this.$store.getters['Place/getProvinceAll'].filter(
      //   item => item.regionid == this.formData.regionId
      // )
    },
    districts() {
      return this.$store.getters['Place/getDistrictAll'].filter(
        item => item.provinceid == this.formData.provinceId
      )
    },
    subDistricts() {
      return this.$store.getters['Place/getSubDistrictAll'].filter(
        item => item.districtid == this.formData.districtId
      )
    }
  },
  methods: {
    checkRegion(region) {
      this.$emit('regionId', this.formData.regionId)
      this.$emit('provinceId', null)
      this.$emit('districtId', null)
      this.$emit('subDistrictId', null)
      if (!region) {
        this.formData.provinceId = null
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkProvince(province) {
      this.$emit('provinceId', this.formData.provinceId)
      this.$emit('districtId', null)
      this.$emit('subDistrictId', null)
      if (!province) {
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkDistrict(district) {
      this.$emit('districtId', this.formData.districtId)
      this.$emit('subDistrictId', null)
      if (!district) {
        this.formData.subDistrictId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
